import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { LEAN_WAITING_SCREEN } from 'apps/auth/constants/ComponentNames';
import { DC_SOURCES } from 'apps/auth/constants/ExtraNames';
import { DELIVERY_METHOD } from 'apps/auth/constants/fieldsName';
import { SEND_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_SEND_GET_DC_SOURCES } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { logWarn } from 'apps/auth/helpers/clientLogger';
import { addScript, removeScript } from 'apps/auth/helpers/DOM';
import { useExtra, useForm } from 'apps/auth/hooks/selectors';
import colors from 'apps/auth/theme/colors';

const STATUS_SUCCESS = 'SUCCESS';
const LEAN_API = 'https://cdn.leantech.me/link/sdk/web/latest/Lean.min.js';
const sandbox = !__isProd__ ? 'true' : 'false';
const customization = {
    theme_color: colors.purple,
    button_text_color: colors.white,
    link_color: colors.purple,
    button_border_radius: '56',
};

const LeanSDK = (props) => {
    const { modalRef, setScreen, href, toggleSpinner, updateExtraByName, leanPaymentIntendId, bankId } = props;
    const extra = useExtra();
    const { fields } = useForm(SEND_FORM_NAME);
    const deliveryMethod = fields?.[DELIVERY_METHOD].value;
    const leanAppToken = extra?.leanAppToken ?? extra?.precheck?.extra?.leanAppToken;
    const leanCustomerId = extra?.leanCustomerId ?? extra?.precheck?.extra?.leanCustomerId;

    useEffect(() => {
        function callbackCreatePaymentSource(responseObject) {
            if (responseObject?.status === STATUS_SUCCESS) {
                toggleSpinner(true);
                apiFetchData(AUTH_SEND_GET_DC_SOURCES, fields)
                    .then((json) => {
                        if (json?.extra?.dcSources) {
                            updateExtraByName(DC_SOURCES, json.extra.dcSources).then(() => setScreen?.(LEAN_WAITING_SCREEN));
                        } else {
                            modalRef?.current?.close();
                        }
                    })
                    .finally(() => toggleSpinner(false))
                    .catch((err) => {
                        logWarn(err);
                        modalRef?.current?.close();
                    });
            } else {
                modalRef?.current?.close();
            }
        }

        function callbackPay(responseObject) {
            if (responseObject?.status === STATUS_SUCCESS && href) {
                window.location.href = href;
            } else {
                modalRef?.current?.close();
            }
        }

        if (leanAppToken) {
            addScript(LEAN_API, () => {
                if (Lean && leanCustomerId && leanPaymentIntendId) {
                    Lean.connect({
                        app_token: leanAppToken,
                        permissions: ['identity', 'accounts', 'transactions', 'balance'],
                        customer_id: leanCustomerId,
                        bank_identifier: bankId,
                        sandbox,
                    });
                    Lean.pay({
                        app_token: leanAppToken,
                        payment_intent_id: leanPaymentIntendId,
                        callback: callbackPay,
                        sandbox,
                        customization,
                    });
                } else if (Lean && leanCustomerId && !leanPaymentIntendId) {
                    Lean.createPaymentSource({
                        app_token: leanAppToken,
                        customer_id: leanCustomerId,
                        callback: callbackCreatePaymentSource,
                        sandbox,
                        customization,
                    });
                }
            });
        }
        return () => {
            if (leanAppToken) {
                removeScript(LEAN_API);
            }
        };
    }, [deliveryMethod, leanAppToken, leanCustomerId, leanPaymentIntendId, bankId, fields, modalRef, setScreen, href, toggleSpinner, updateExtraByName]);

    return <div id="lean-link" />;
};

LeanSDK.propTypes = {
    modalRef: PropTypes.shape({ current: PropTypes.object }),
    href: PropTypes.string,
    setScreen: PropTypes.func,
    leanPaymentIntendId: PropTypes.string,
    bankId: PropTypes.string,
};
export default connect(null, { updateExtraByName, toggleSpinner })(LeanSDK);
